// GLOBAL THEME JS

// DOM SELECTION 

//Functions Site Wide

// HEADER

// Mobile Nav toggle open
document.addEventListener('DOMContentLoaded', function() {
  const menuToggle = document.getElementById('hamburger-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  const htmlElement = document.documentElement;
  
  menuToggle.addEventListener('click', function() {
    mobileNav.classList.toggle('active');
    menuToggle.classList.toggle('active');
    menuToggle.classList.toggle('active-close');
    htmlElement.classList.toggle('overflow-hidden');
  });

});

// Header Mobile Menu Accordion

const mobNavAcc = document.getElementsByClassName("accordion-mobile");

for (i = 0; i < mobNavAcc.length; i++) {
  mobNavAcc[i].onclick = function() {

	if( !this.classList.contains('active') ){
    	closeAll();
    }
	
  this.classList.toggle("active");
    const panel = this.nextElementSibling;
    if (panel.style.maxHeight){
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  }
  
}

function closeAll(){
	 for (i = 0; i < mobNavAcc.length; i++) {
    	mobNavAcc[i].classList.remove("active");
        mobNavAcc[i].nextElementSibling.style.maxHeight = null;
    }
}

// Tabs

function activateTabs(evt, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tab-contents");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tab-button");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";
}

// Localization form JavaScript

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);

// Recently View Section

// function updateRecentlyViewed(handle) {
//   let viewedProducts = JSON.parse(localStorage.getItem('viewedProducts') || '[]');
  
//   // Remove duplicates
//   viewedProducts = viewedProducts.filter(existing => existing !== handle);
  
//   // Add to front and limit to 4 items
//   viewedProducts.unshift(handle);
//   viewedProducts = viewedProducts.slice(0, 10);
  
//   localStorage.setItem('viewedProducts', JSON.stringify(viewedProducts)); 
// }
